module.exports = __webpack_public_path__ + "img/animated-gifs-under-construction.4ccdafbd.gif";